import cookie from "react-cookies";
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY || "";

export default class EncryptedCookieGateway {
  static set(key, value, options = {}) {
    try {
      const data = typeof value === "string" ? value : JSON.stringify(value);
      const encryptedValue = CryptoJS.AES.encrypt(data, SECRET_KEY).toString();

      cookie.save(key, encryptedValue, { path: "/", ...options });
    } catch (error) {
      console.error("Error setting encrypted cookie:", error);
    }
  }

  static get(key) {
    try {
      const encryptedValue = cookie.load(key);
      if (!encryptedValue) return null;

      const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      try {
        return JSON.parse(decrypted);
      } catch {
        return decrypted;
      }
    } catch (error) {
      console.error("Error reading encrypted cookie:", error);
      return null;
    }
  }

  static remove(key, options = {}) {
    try {
      cookie.remove(key, { path: "/", ...options });
    } catch (error) {
      console.error("Error removing encrypted cookie:", error);
    }
  }
}
